module.exports = __webpack_public_path__ + "img/bh.61da1a76.jpg";